// @flow
import React, { Component } from 'react';
import { StyleSheet, Image, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import { GradientPage } from '../../components/common';
import theme from '../../theme-config';
import I18n from '../../lib/i18n';
import { DownloadAppButtons } from '../../components/common';

export default class ExternalWebview extends Component<void, void> {
  styles = getStyles();

  render() {
    return (
      <GradientPage>
        <View style={this.styles.container}>
          <Image style={this.styles.imageStyle} source={theme.brandIcon} />
          <View style={this.styles.textContainer}>
            <Text style={[this.styles.text, this.styles.welcomeText]}>
              {I18n.t('Dashboard.ExternalWebview.headText')}
            </Text>
            <Text style={[this.styles.text, this.styles.downloadAppText]}>
              {I18n.t('Dashboard.ExternalWebview.downloadTheApp')}
            </Text>
          </View>
          <DownloadAppButtons />
        </View>
      </GradientPage>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    imageStyle: {
      width: 138,
      height: 138,
      borderRadius: 12,
    },
    imgContainer: {
      flexDirection: 'row',
      width: '50%',
      justifyContent: 'space-around',
    },
    text: {
      color: theme.signUpTextColor,
      textAlign: 'center',
      marginBottom: 20,
    },
    welcomeText: {
      fontSize: 25,
    },
    downloadAppText: {
      fontSize: 16,
    },
    textContainer: {
      marginTop: 50,
      marginBottom: 40,
    },
  });
